// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColorPaletteSelectionActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { curry } from 'lodash/fp';
import ColorPalette from 'logic/models/Izenda.ColorPalette';

/**
 * On closing popup handler.
 * @param {Object} props
 * @param {Object} closeCallback
 * @param {string} type
 */
function onClosing(props: any, closeCallback: any, type: string) {
  const { store, selectedPaletteName, updateSelectedPalette, onChange } = props;
  if (type === 'accept') {
    const doesNeedToUpdate = store.currentColorPalette !== selectedPaletteName;

    if (doesNeedToUpdate) {
      store.updateOriginalPalette(store.currentColorPalette);
      updateSelectedPalette && updateSelectedPalette(store.currentColorPalette);
    }

    // Always call onChange with properties editor with case update isDefaultTheme
    onChange &&
      onChange({
        value: {
          colorPalette: store.currentColorPalette,
          isDefaultTheme: store.currentColorPalette === store.defaultColorPalette
        }
      });

    return props.onAccept();
  } else if (type === 'cancel') {
    store.resetSelectedPalette();

    return props.onReject();
  }
}

/**
 * On select a color palette handler
 * @param {Object} props
 * @param {ColorPalette} colorPalette
 * @param {Object} e
 */
function onSelectColorPalette(props: any, colorPalette: ColorPalette, e: any) {
  props.store.updateSelectedPalette(colorPalette.name);
}

export default withHandlers({
  onClosing: curry(onClosing),
  onSelectColorPalette: curry(onSelectColorPalette)
});



// WEBPACK FOOTER //
// ./ui/share/components/controls/ColorPalette/Izenda.ColorPaletteSelectionActions.js